import moment from 'moment';

global.___now = localStorage.getItem('___now') || undefined;

const now = () => moment(global.___now).utc().format();

export default (state = now(), action = {}) => {
  switch (action.type) {
    case 'SET_TIME':
      return action.payload;
    case 'RESET_TIME':
      return now();
    default:
      return state;
  }
};
